var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 596,
    viewBox: "0 0 304 596",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_637_1398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.347 562.402C250.347 567.699 245.823 571.999 240.245 571.999H63.076C57.496 571.999 52.9766 567.699 52.9766 562.402V505.244C52.9766 499.93 57.496 495.629 63.076 495.629H240.245C245.823 495.629 250.347 499.93 250.347 505.244V562.402Z",
    fill: "#7A2C00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M240.245 495.629H229.372C232.184 504.265 229.31 560.196 219.569 564.604C210.226 568.849 70.967 568.32 64.7705 564.604C56.4928 559.647 55.4971 506.197 58.1972 496.877C55.1003 498.512 52.9766 501.617 52.9766 505.244V562.402C52.9766 567.699 57.496 571.999 63.076 571.999H240.245C245.823 571.999 250.347 567.699 250.347 562.402V505.244C250.347 499.927 245.823 495.629 240.245 495.629Z",
    fill: "#491D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.28 499.104L242.545 484.489C240.701 478.978 234.669 474.902 229.086 474.902H152.615H150.699H74.2375C68.6574 474.902 62.6182 478.978 60.7765 484.489L54.041 499.104C49.7412 507.623 58.5654 508.691 64.1405 508.691H151.115H152.188H239.181C244.756 508.691 253.58 507.623 249.28 499.104Z",
    fill: "url(#paint0_linear_637_1398)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M249.28 499.102L248.809 498.078C246.992 502.756 242.081 505.798 234.217 505.556C220.462 505.169 98.5242 505.529 72.4981 505.951C64.692 506.068 56.3269 505.052 54.5251 498.051L54.041 499.102C49.7412 507.62 58.5654 508.689 64.1405 508.689H239.181C244.756 508.689 253.58 507.62 249.28 499.102Z",
    fill: "#F78406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.094 539.378C238.094 552.404 227.513 562.97 214.489 562.97H88.8206C75.7888 562.97 65.2227 552.404 65.2227 539.378C65.2227 526.323 75.7888 515.768 88.8206 515.768H214.486C227.511 515.765 238.094 526.323 238.094 539.378Z",
    fill: "url(#paint1_linear_637_1398)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M170.543 543.416C190.084 540.066 214.48 536.252 234.357 526.71C230.18 520.155 222.873 515.768 214.49 515.768H88.8217C78.016 515.768 68.9921 523.076 66.207 533.005C97.1992 548.373 136.896 549.162 170.543 543.416Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M153.524 549.263C135.531 549.443 115.097 548.941 97.9629 554.927C91.6442 557.118 85.5476 559.29 79.2812 560.924C82.211 562.235 85.4203 562.971 88.8217 562.971H214.488C220.345 562.971 225.63 560.762 229.745 557.235C205.009 551.445 180.478 548.959 153.524 549.263Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M203.421 555.356C203.313 555.366 203.241 555.429 203.121 555.429C187.13 555.356 171.305 553.167 155.346 552.86C148.219 552.735 141.129 553.112 134.047 553.534C132.981 553.821 131.923 554.018 130.875 554.325C122.175 556.849 113.701 559.991 105.176 562.972H214.491C216.802 562.972 218.993 562.532 221.079 561.921C215.359 559.245 209.45 557.116 203.421 555.356Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M90.8721 524.349C129.216 535.759 182.179 533.615 220.888 516.754C218.846 516.17 216.723 515.766 214.484 515.766H88.8183C84.783 515.766 81.0172 516.879 77.7031 518.674C81.716 520.8 86.0383 522.632 90.5028 524.302C90.6276 524.349 90.7374 524.294 90.8721 524.349Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.735 539.378C232.735 549.936 222.825 558.5 210.587 558.5H92.7193C80.4911 558.5 70.5938 549.936 70.5938 539.378C70.5938 528.802 80.4911 520.221 92.7193 520.221H210.589C222.827 520.221 232.735 528.802 232.735 539.378Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.939 539.374C230.939 548.954 221.246 556.726 209.285 556.726H94.0278C82.0691 556.726 72.3789 548.951 72.3789 539.374C72.3789 529.794 82.0716 522.002 94.0278 522.002H209.285C221.246 522.002 230.939 529.794 230.939 539.374Z",
    fill: "url(#paint2_linear_637_1398)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M95.6599 523.625C118.764 524.289 188.951 523.096 210.051 524.191C225.73 525.007 229.788 535.289 230.579 536.561C228.892 528.32 220.05 522.01 209.285 522.01H94.0278C82.0691 522.01 72.3789 529.802 72.3789 539.382C72.3789 541.888 73.0727 544.257 74.2655 546.411C72.3789 529.323 86.8281 523.363 95.6599 523.625Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.303 534.078C115.303 535.63 114.634 536.843 113.541 537.787C116.037 538.765 117.579 540.642 117.579 543.945C117.579 550.569 110.065 551.191 103.227 551.191H85.8633V546.523H89.7738V532.158H85.8633V527.83H104.056C109.973 527.83 115.303 528.477 115.303 534.078ZM106.254 536.726C106.816 536.529 107.305 536.017 107.305 534.697C107.305 532.308 105.76 532.156 103.796 532.156H97.5974V536.726H106.254ZM103.375 546.52C108.218 546.52 109.122 545.839 109.122 543.945C109.122 541.369 107.914 541.037 102.92 541.037H97.5974V546.523H103.375V546.52Z",
    fill: "#491D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.594 546.521H124.524V532.156H120.594V527.828H150.086V536.886H144.88V532.156H132.34V537.021H140.947V541.367H132.34V546.521H144.88V542.113H150.086V551.189H120.594V546.521Z",
    fill: "#491D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.53 533.935C161.53 534.824 162.858 535.031 164.402 535.3C170.624 536.421 181.11 535.425 181.11 544.403C181.11 549.053 176.748 552.044 167.23 552.044C163.524 552.044 160.287 551.352 158.326 550.346V551.352H153.098V541.872H158.326V543.228C158.326 546.37 163.863 547.134 167.866 547.134C170.097 547.134 173.314 546.56 173.314 544.925C173.314 542.626 170.165 543.148 164.36 542.411C161.57 542.017 153.781 540.599 153.781 534.726C153.781 528.344 161.043 526.719 166.169 526.719C169.643 526.719 173.798 527.967 175.64 529.25V527.4H180.873V536.503H175.64V535.148C175.64 532.68 170.542 531.639 167.083 531.639C162.992 531.636 161.53 532.023 161.53 533.935Z",
    fill: "#491D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.143 527.83H217.466V536.888H212.25V532.158H204.689V546.523H209.688V551.191H192.042V546.523H196.905V532.158H189.356V536.888H184.141L184.143 527.83Z",
    fill: "#491D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.093 478.259C223.322 461.668 199.364 457.699 185.928 455.914C173.218 454.237 153.758 455.735 151.654 455.907C149.571 455.737 130.098 454.237 117.393 455.914C103.957 457.701 80.0072 461.67 78.2329 478.259C75.6425 502.552 147.04 503.296 151.447 503.314V503.331C151.447 503.331 151.627 503.331 151.654 503.331C151.699 503.331 151.879 503.331 151.879 503.331V503.314C156.284 503.299 227.684 502.552 225.093 478.259Z",
    fill: "url(#paint3_linear_637_1398)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M114.475 480.242C111.747 479.856 109.077 479.309 106.544 478.42C103.15 477.217 98.8252 474.434 95.0919 475.665C91.6006 476.813 91.4284 480.36 93.1579 483.133C95.4662 486.814 100.475 487.334 104.213 488.779C111.068 491.417 117.492 491.831 124.659 492.89C128.937 493.526 134.212 494.307 138.285 492.188C143.306 489.567 138.188 483.974 134.659 482.878C130.354 481.54 125.014 481.333 120.394 480.911C118.423 480.719 116.429 480.522 114.475 480.242Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M225.093 478.259C223.322 461.668 199.364 457.7 185.928 455.915C175.934 454.595 161.796 455.241 155.178 455.655C163.009 461.653 169.203 468.61 169.625 479.777C170.002 489.589 157.928 493.495 150.309 494.518C134.49 496.61 115.641 496.647 100.573 490.927C87.8407 486.107 82.4628 481.032 80.6186 471.39C79.3783 473.41 78.5124 475.663 78.2329 478.259C75.6425 502.553 147.04 503.297 151.447 503.314V503.332C151.447 503.332 151.627 503.332 151.654 503.332C151.699 503.332 151.879 503.332 151.879 503.332V503.314C156.284 503.299 227.684 502.553 225.093 478.259Z",
    fill: "#C96C06"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M222.569 486.592C226.32 467.48 209.937 463.618 198.457 458.052C193.95 457.056 189.558 456.4 185.932 455.916C182.975 455.529 179.658 455.324 176.274 455.217C189.585 461.205 199.598 476.378 190.042 489.734C185.061 496.708 174.235 499.96 166.502 502.391C166 502.544 165.488 502.688 164.984 502.848C182.932 501.765 213.635 498.191 222.569 486.592Z",
    fill: "#C96C06"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M196.381 460.97C196.072 460.873 195.745 460.808 195.433 460.721C204.342 468.898 204.107 479.68 201.424 486.495C199.458 491.477 193.875 497.851 188.949 500.213C198.939 498.56 208.901 496.029 215.814 492.106C224.107 478.799 209.912 465.199 196.381 460.97Z",
    fill: "#BC5E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.686 486.24C109.681 487.36 115.573 489.759 117.47 487.228C120.217 483.574 113.242 481.447 108.875 480.953C103.04 480.297 99.8436 483.716 106.686 486.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M93.1866 471.172C101.305 475.967 119.999 482.816 151.553 482.799C189.942 482.754 211.179 472.922 213.539 472.223C217.215 471.137 220.375 471.165 223.09 472.016C216.761 460.624 197.478 457.454 185.926 455.919C184.803 455.767 183.61 455.659 182.395 455.552C182.143 455.535 181.883 455.515 181.624 455.49C180.428 455.407 179.201 455.327 177.97 455.275C177.796 455.265 177.616 455.265 177.441 455.258C176.296 455.213 175.143 455.185 174.002 455.168C173.75 455.158 173.501 455.15 173.254 455.15C172.011 455.14 170.763 455.14 169.543 455.14C169.283 455.15 169.031 455.15 168.784 455.15C167.649 455.16 166.546 455.185 165.468 455.213C165.333 455.213 165.198 455.213 165.063 455.223C163.878 455.25 162.753 455.285 161.652 455.33C161.422 455.34 161.203 455.357 160.978 455.365C158.83 455.445 156.93 455.555 155.396 455.644C155.323 455.654 155.243 455.654 155.176 455.662C153.379 455.769 152.102 455.877 151.652 455.914C149.569 455.744 130.096 454.244 117.391 455.922C107.284 457.269 91.32 459.908 83.2344 468.177C86.4137 468.13 89.9424 469.26 93.1866 471.172Z",
    fill: "#7A3100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.206 381.615C251.234 436.593 206.691 481.184 151.709 481.221C96.732 481.266 52.144 436.71 52.1016 381.743C52.0617 326.746 96.6122 282.147 151.574 282.119C206.556 282.074 251.171 326.628 251.206 381.615Z",
    fill: "url(#paint4_linear_637_1398)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M169.375 283.885C177.83 290.689 190.5 304.327 196.684 316.752C212.565 348.774 211.113 394.533 183.125 420.649C146.9 454.395 97.6977 439.466 75.2128 411.314C66.5383 400.469 57.9561 386.346 53.1098 371.615C52.7803 374.989 52.1016 378.257 52.1016 381.741C52.1415 436.711 96.7319 481.264 151.709 481.219C206.691 481.185 251.234 436.593 251.206 381.614C251.171 332.714 215.852 292.269 169.375 283.885Z",
    fill: "#FFBA00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M151.575 282.117C147.061 282.117 142.631 282.512 138.264 283.096C188.587 282.082 271.344 337.364 229.292 419.276C202.135 472.188 146.377 474.27 114.309 461.318C75.4836 445.626 62.7687 414.95 52.3398 386.348C54.8129 439.181 98.2954 481.266 151.708 481.222C206.69 481.187 251.233 436.595 251.205 381.616C251.17 326.629 206.555 282.075 151.575 282.117Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M213.805 303.98C260.783 351.22 256.494 423.821 209.515 455.314C136.677 504.078 81.5481 450.564 74.7852 444.666C93.0201 466.965 120.646 481.24 151.71 481.222C206.692 481.187 251.235 436.596 251.208 381.616C251.171 350.187 236.559 322.204 213.805 303.98Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0588 377.773C62.5722 351.336 78.626 318.056 104.537 301.887C113.424 296.348 131.115 294.886 141.145 296.725C167.847 301.645 173.809 334.475 167.128 357.036C158.548 386.008 123.466 402.202 96.1897 387.605C91.1512 384.909 87.1508 381.552 84.0588 377.773Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8292 327.213C81.2826 338.193 88.2926 352.744 102.762 346.684C111.861 342.833 118.177 333.326 115.085 323.396C110.895 310.013 93.935 320.039 88.8292 327.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.491 309.706C114.194 314.94 124.9 312.991 127.565 312.489C129.317 312.13 133.554 312.005 134.982 310.937C138.153 308.558 134.48 305.201 132.119 304.293C128.281 302.785 117.96 304.382 115.956 308.468C115.741 308.925 115.589 309.339 115.491 309.706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4631 358.523C89.7326 355.587 88.4649 351.906 86.5109 351.017C80.8884 348.549 81.7369 357.794 82.8624 359.896C83.7707 361.673 86.1041 364.106 88.385 361.466C89.0239 360.742 89.3508 359.726 89.4631 358.523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.75 307.22C223.75 317.354 191.468 325.561 151.656 325.561C111.84 325.561 79.5625 317.354 79.5625 307.22C79.5625 297.111 111.84 288.887 151.656 288.887C191.468 288.889 223.75 297.111 223.75 307.22Z",
    fill: "#C96C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.825 305.489C222.825 315.58 190.852 323.739 151.433 323.739C112.001 323.739 80.0352 315.578 80.0352 305.489C80.0352 295.442 112.003 265.275 151.433 265.275C190.852 265.275 222.825 295.442 222.825 305.489Z",
    fill: "url(#paint5_linear_637_1398)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M214.079 291.602C212.594 294.662 210.071 297.562 206.265 300.141C190.625 310.769 169.536 313.662 151.081 315.069C135.449 316.262 120.316 314.89 105.103 310.983C96.9999 308.902 85.8323 304.636 83.1895 298.146C81.1357 301.064 80.0352 303.63 80.0352 305.49C80.0352 315.581 112.003 323.74 151.433 323.74C190.855 323.74 222.825 315.579 222.825 305.49C222.825 302.33 219.644 297.175 214.079 291.602Z",
    fill: "#E58800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M151.432 265.275C131.522 265.275 113.537 272.951 100.59 281.866C114.46 290.52 129.583 291.823 145.794 292.01C156.233 292.145 165.402 291.93 172.838 296.481C181.58 301.832 183.143 312.829 180.585 322.147C205.475 319.302 222.824 312.927 222.824 305.484C222.827 295.442 190.854 265.275 151.432 265.275Z",
    fill: "#E58800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M220.025 310.55C219.953 310.118 219.873 309.679 219.756 309.25C218.633 305.381 216.691 301.529 214.51 298.18C212.683 295.387 210.602 293.223 208.321 291.114C207.45 290.305 206.544 289.506 205.601 288.69C200.001 283.815 194.201 280.251 186.672 282.675C184.114 283.511 180.713 284.469 178.424 285.844C178.182 285.997 176.737 287.37 176.782 287.38C183.316 289.129 188.514 294.111 191.234 300.351C194.338 307.49 190.84 315.352 185.771 321.493C202.237 319.169 214.735 315.247 220.025 310.55Z",
    fill: "#C66D02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7192 297.11C97.0696 301.753 99.6775 306.141 103.91 308.342C107.481 310.182 111.753 310.828 115.739 310.766C119.644 310.711 123.63 311.09 127.593 310.946C132.324 310.776 137.046 310.067 141.613 308.782C145.059 307.821 148.792 307.336 151.75 305.19C154.797 302.981 156.601 299.372 152.723 297.075C149.878 295.405 146.027 295.927 142.885 295.405C134.316 294.013 124.076 295.038 116.061 291.492C113.311 290.261 109.667 289.705 106.685 289.814C102.769 289.974 99.9969 293.528 98.7192 297.11Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.648 300.828C123.657 299.383 123.505 298.235 122.347 297.389C120.413 295.971 115.674 295.342 113.365 295.477C99.7997 296.161 112.524 307.383 121.648 300.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.985 277.333C197.062 272.164 186.821 271.647 181.872 264.384C178.341 259.192 179.831 252.478 182.271 248.501C178.982 251.779 166.509 254.217 151.591 254.217C136.603 254.217 124.087 251.766 120.863 248.459C123.324 252.425 124.856 259.174 121.302 264.386C116.361 271.652 106.112 272.166 102.199 277.335C98.3733 282.362 114.395 287.794 128.754 289.706C141.771 291.438 161.146 291.303 174.42 289.706C188.805 287.961 204.803 282.36 200.985 277.333Z",
    fill: "url(#paint6_linear_637_1398)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.983 277.336C198.904 274.605 195.053 273.155 191.158 271.338C184.597 281.132 169.212 282.964 156.49 283.062C141.878 283.169 117.454 286.446 106.506 273.956C104.772 274.895 103.245 275.948 102.199 277.333C98.3733 282.36 114.395 287.792 128.754 289.704C141.771 291.436 161.146 291.301 174.42 289.704C188.802 287.964 204.801 282.363 200.983 277.336Z",
    fill: "#E58800"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.985 277.333C197.062 272.164 186.821 271.647 181.872 264.384C178.341 259.192 179.831 252.478 182.271 248.501C178.982 251.779 166.509 254.217 151.591 254.217C136.603 254.217 124.088 251.766 120.863 248.459C123.169 252.186 124.609 258.333 121.854 263.395C123.948 264.396 129.099 266.458 144.601 267.276C151.099 267.621 156.585 267.608 162.167 271.165C169.002 275.528 170.033 283.296 168.126 290.307C170.325 290.127 172.454 289.94 174.423 289.706C188.805 287.961 204.804 282.36 200.985 277.333Z",
    fill: "#E58800"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.473 261.331C172.988 261.331 177.422 262.365 181.705 264.082C178.421 258.933 179.883 252.401 182.271 248.499C178.982 251.777 166.509 254.215 151.591 254.215C136.603 254.215 124.088 251.764 120.863 248.457C122.391 250.916 123.506 254.455 123.306 258.012C137.239 260.935 150.703 261.653 164.997 261.169C166.247 261.139 167.38 261.214 168.473 261.331Z",
    fill: "#E58800"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M174.419 289.706C184.936 288.441 196.28 285.111 200.148 281.429C195.319 273.809 186.049 274.82 181.012 268.857C176.683 263.743 175.125 256.929 177.656 250.953C174.429 252.071 169.96 252.985 164.689 253.544C156.803 263.86 124.728 256.671 123.348 256.552C123.395 257.508 123.34 258.456 123.203 259.412C133.153 260.605 143.045 262.088 153.052 263.206C160.097 263.992 167.364 267.634 171.984 273.095C174.339 275.866 178.392 281.774 173.636 289.791C173.885 289.751 174.165 289.734 174.419 289.706Z",
    fill: "#C46D05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.717 271.432C133.096 269.436 120.913 263.847 117.282 274.817C116.226 277.997 119.333 279.218 121.956 279.946C126.5 281.239 132.677 281.734 137.336 280.7C139.919 280.144 145.871 278.688 146.57 275.658C147.276 272.606 142.836 271.992 140.717 271.432Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.171 273.903C133.184 272.937 133.112 272.166 132.518 271.597C131.545 270.641 129.166 270.209 127.996 270.296C121.173 270.755 127.577 278.348 132.171 273.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.144 246.782C183.144 250.888 169.024 254.218 151.595 254.218C134.164 254.218 120.039 250.888 120.039 246.782C120.039 242.676 134.224 221.814 151.65 221.814C169.079 221.814 183.144 242.676 183.144 246.782Z",
    fill: "url(#paint7_linear_637_1398)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M155.805 222.256C159.341 225.673 161.914 230.111 161.944 234.971C161.989 242.678 156.11 248.566 148.611 249.877C140.725 251.285 128.087 251.349 122.527 244.211C122.158 243.739 121.888 243.242 121.586 242.751C120.593 244.535 120.039 245.995 120.039 246.782C120.039 250.888 134.164 254.217 151.595 254.217C169.027 254.217 183.144 250.888 183.144 246.782C183.144 243.02 171.26 225.129 155.805 222.256Z",
    fill: "#E58800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M172.625 233.614C168.949 229.99 164.402 227.11 159.633 224.971C167.249 232.611 171.422 243.93 166.261 253.355C172.108 252.634 176.817 251.486 179.774 250.098C179.477 245.381 178.127 240.898 175.115 236.827C174.344 235.773 173.513 234.69 172.625 233.614Z",
    fill: "#E58800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M181.639 242.806C177.592 235.403 165.725 221.814 151.65 221.814C150.268 221.814 148.913 221.987 147.575 222.234C146.362 222.793 145.182 223.479 143.859 224.233C139.891 226.512 135.799 228.229 132.073 230.97C131.237 231.594 130.403 232.053 129.57 232.517C126.333 235.712 123.79 239.077 122.141 241.808C124.489 240.228 126.867 238.563 129.587 237.507C134.202 235.712 139.203 234.714 144.039 234.177C150.458 233.466 157.537 234.2 163.741 236.102C169.851 237.979 175.645 240.956 181.639 242.806Z",
    fill: "#C46D05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.383 8L193.561 92.837L287.321 106.193L219.689 172.517L235.965 265.846L151.997 222.006L68.2742 266.33L84.0311 172.907L16 106.962L109.7 93.0791L151.383 8Z",
    fill: "url(#paint8_linear_637_1398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.988 29.666L188.542 101.229L267.651 112.494L210.605 168.434L224.328 247.168L153.497 210.18L82.8804 247.565L96.1667 168.764L38.7891 113.138L117.823 101.424L152.988 29.666Z",
    fill: "url(#paint9_linear_637_1398)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M259.94 120.054L267.651 112.494L188.542 101.229L152.988 29.666L117.823 101.421L38.7891 113.135L94.7717 167.406C132.814 127.545 200.593 114.723 259.94 120.054Z",
    fill: "#FFFF71"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M223.587 106.219C231.096 109.9 250.434 113.307 258.107 116.714C259.989 117.541 216.649 150.867 206.687 165.07C200.914 173.292 221.937 242.588 219.975 240.911C198.94 222.995 153.392 204.906 153.392 204.906C143.864 211.548 120.653 223.272 112.852 231.698L153.499 210.178L224.333 247.166L210.61 168.434L267.655 112.494L223.587 106.219Z",
    fill: "#B54C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2789 116.09C45.9413 114.812 114.042 110.122 119.967 104.604C126.887 98.1566 152.648 38.8763 153.499 40.7633C158.271 51.3115 170.848 68.187 175.912 75.9396C175.929 75.9421 175.967 75.9421 175.984 75.9471L152.988 29.666L117.823 101.421L38.7891 113.135L96.1667 168.759L82.8804 247.56L85.6729 246.078C91.4102 226.172 99.4259 187.851 100.549 166.927C100.706 163.844 55.8112 124.315 47.2789 116.09Z",
    fill: "#FFFFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.875 118.14C132.604 117.132 136.52 113.365 137.533 103.506H167.1V175.069H182.448V193.2H121.761V175.069H137.256V134.352H120.875V118.14Z",
    fill: "#7A3100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.32 106.839H167.1V103.504H137.533C136.52 113.363 132.604 117.132 120.875 118.138V134.35H123.653V121.48C135.387 120.482 139.297 116.68 140.32 106.839Z",
    fill: "#512202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.375 438.513L150.522 387.664L210.428 387.449L202.609 416.86L181.14 438.405L151.77 446.333L122.375 438.513Z",
    fill: "#B53004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.589 436.827L172.509 424.115L181.136 438.407L151.766 446.335L176.589 436.827Z",
    fill: "#CC3705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.375 438.515L129.939 424.977L127.618 436.828L151.77 446.335L122.375 438.515Z",
    fill: "#B73104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.723 387.557L210.426 387.449L202.608 416.86L181.138 438.405L150.723 387.557Z",
    fill: "#B73104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.914 387.477L210.425 387.449L197.616 390.976L202.607 416.86L192.914 387.477Z",
    fill: "#9E2A04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.604 416.861L181.135 438.407L192.911 422.472L172.562 424.08L202.604 416.861Z",
    fill: "#9E2A04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.372 438.513L100.828 417.039L92.8945 387.664L150.894 387.449L122.372 438.513Z",
    fill: "#E83C03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.372 438.516L100.828 417.043L122.372 433.454L129.936 424.978L122.372 438.516Z",
    fill: "#CE3502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9149 390.775L100.828 417.043L92.8945 387.668L108.043 387.605L96.9149 390.775Z",
    fill: "#D83B07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.915 387.559L202.608 416.862L171.695 424.312L192.915 387.559Z",
    fill: "#CE3502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.915 387.559L202.608 416.862L171.695 424.312L199.728 414.743L192.915 387.559Z",
    fill: "#CC3705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.258 424.314H171.69L151.763 446.337L129.258 424.314Z",
    fill: "#CC3705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.258 424.314L151.566 442.897L171.69 424.314L151.763 446.337L129.258 424.314Z",
    fill: "#E83C03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.262 424.312L100.828 417.042L108.043 387.559L129.262 424.312Z",
    fill: "#E2704A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.262 424.312L100.828 417.042L108.043 387.559L104.452 415.354L129.262 424.312Z",
    fill: "#F49272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.953 336.602L202.51 358.075L210.426 387.45L150.895 387.558L180.953 336.602Z",
    fill: "#C63302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.509 358.076L210.425 387.452L202.509 368.033L192.914 387.487L202.509 358.076Z",
    fill: "#B73104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.948 336.602L177.334 349.628L202.504 358.075L172.57 350.796L180.948 336.602Z",
    fill: "#B73104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.188 336.71L151.555 328.775L180.95 336.603L150.891 387.559L122.188 336.71Z",
    fill: "#EF511D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.555 328.775L172.572 346.639L180.95 336.603L173.136 351.811L151.555 328.775Z",
    fill: "#E83C03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.188 336.71L151.555 328.775L126.577 337.806L130.71 351.811L122.188 336.71Z",
    fill: "#E83C03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8945 387.665L100.718 358.265L122.19 336.709L150.894 387.45L92.8945 387.665Z",
    fill: "#F2764D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M92.8945 387.664L100.718 358.264L96.4207 384.407L110.643 387.664H92.8945Z",
    fill: "#FFCCBB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M100.719 358.265L122.19 336.709L108.043 353.507L130.141 350.797L100.719 358.265Z",
    fill: "#D83B07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.695 350.797L202.51 358.075L192.915 387.558L171.695 350.797Z",
    fill: "#D13400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.695 350.797L202.51 358.075L192.915 387.558L199.416 359.665L171.695 350.797Z",
    fill: "#EF511D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.141 350.798L151.557 328.775L172.575 350.798H130.141Z",
    fill: "#EF9172"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M130.141 350.798L151.557 328.775L172.575 350.798L151.57 331.818L130.141 350.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.043 387.558L100.719 358.265L130.141 350.797L108.043 387.558Z",
    fill: "#FC9C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.043 387.558L100.719 358.265L130.141 350.797L103.836 360.284L108.043 387.558Z",
    fill: "#FFCCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.723 387.559H192.915L171.695 424.312L150.723 387.559Z",
    fill: "#D83B07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.723 387.559H192.915L154.568 389.992L171.695 424.312L150.723 387.559Z",
    fill: "#FC9C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.258 424.312L150.717 387.559L171.69 424.312H129.258Z",
    fill: "#EF693B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.258 424.312L150.717 387.559L134.144 421.235L171.69 424.312H129.258Z",
    fill: "#FCB198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.263 424.312L108.043 387.559H150.722L129.263 424.312Z",
    fill: "#F49272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.263 424.312L108.043 387.559H150.722L112.186 389.992L129.263 424.312Z",
    fill: "#FFCCBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.141 350.797H172.575L150.721 387.558L130.141 350.797Z",
    fill: "#FFCCBB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M130.141 350.797H172.575L150.721 387.558L168.485 352.861L130.141 350.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.576 350.797L192.915 387.558H150.723L172.576 350.797Z",
    fill: "#FC9C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.576 350.797L155.19 385.035L192.915 387.558H150.723L172.576 350.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.043 387.558L130.141 350.797L150.722 387.558H108.043Z",
    fill: "#FCB198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.043 387.558L130.141 350.797L150.722 387.558L130.141 355.33L108.043 387.558Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_637_1398",
    x: 0,
    y: 0,
    width: 303.32,
    height: 596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_637_1398"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_637_1398",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_637_1398",
    x1: 151.661,
    y1: 508.69,
    x2: 151.661,
    y2: 474.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0485,
    stopColor: "#AF4B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6242,
    stopColor: "#682601"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_637_1398",
    x1: 65.2237,
    y1: 539.368,
    x2: 238.093,
    y2: 539.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D47E01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5091,
    stopColor: "#F0AF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_637_1398",
    x1: 72.3787,
    y1: 539.365,
    x2: 230.939,
    y2: 539.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E28601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6364,
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8909,
    stopColor: "#FFBA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89A01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_637_1398",
    x1: 86.3696,
    y1: 454.446,
    x2: 217.62,
    y2: 502.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0324,
    stopColor: "#FFBD10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1176,
    stopColor: "#FFDE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1887,
    stopColor: "#FFF33D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2364,
    stopColor: "#FFFA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#FFF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#FFBF12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7636,
    stopColor: "#FFAA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E58800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_637_1398",
    x1: 69.0813,
    y1: 326.039,
    x2: 234.24,
    y2: 437.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#FFF500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_637_1398",
    x1: 93.4163,
    y1: 273.955,
    x2: 213.529,
    y2: 327.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0481,
    stopColor: "#FFBD10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    stopColor: "#FFDE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#FFF33D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    stopColor: "#FFFA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#FFF13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5642,
    stopColor: "#FFDA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7278,
    stopColor: "#FFB308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7636,
    stopColor: "#FFAA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E58800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_637_1398",
    x1: 101.625,
    y1: 269.704,
    x2: 201.558,
    y2: 269.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0481,
    stopColor: "#FFBD10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1749,
    stopColor: "#FFDE2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2806,
    stopColor: "#FFF33D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    stopColor: "#FFFA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#FFF13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5642,
    stopColor: "#FFDA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7278,
    stopColor: "#FFB308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7636,
    stopColor: "#FFAA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E58800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_637_1398",
    x1: 127.064,
    y1: 230.193,
    x2: 180.18,
    y2: 253.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1186,
    stopColor: "#FFF349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFFA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3582,
    stopColor: "#FFF13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6128,
    stopColor: "#FFDA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9305,
    stopColor: "#FFB308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_637_1398",
    x1: 222.144,
    y1: 272.921,
    x2: 99.9924,
    y2: 34.3084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B25900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BC26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_637_1398",
    x1: 50.5622,
    y1: 168.04,
    x2: 269.494,
    y2: 121.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3515,
    stopColor: "#FFFA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward3);
export default __webpack_public_path__ + "static/media/Award3.17bfa41c6f1475f265426251f57a44cd.svg";
export { ForwardRef as ReactComponent };